module.exports = __webpack_public_path__ + "static/img/new_thumb6.0f52453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_thumb6.jpg
// module id = 56OJ
// module chunks = 0